export const environment = {
  production: false,
  baseUrl: 'https://backend-staging.dealflow.no/api/deck/',
  loginClientid: 'N7cScSW6SrxW6PHwxcZic0iQIYm1YWQi9N3xKG5A',
  loginClientsecret: '3lx18Ach64tXm4DYU8QyjEFvYB7x9ipfEoBNsyZARSqn84pssIumjng2FiXBK21z9lRBJSge6TZg' +
    'Q4yaTLLNt1l117CFfbVIG0d9XkAJje2ECmp0h0L4klCTf7nxrdvu',
  AWS_COGNITO_POOL:'eu-north-1:538ccd3a-1414-457c-ab75-bc62bf6d8d88',
  AWS_LOCATION_INDEX: 'DF.addresses'
};
